import { NavigateFunction, NavigateOptions, useNavigate } from "react-router";
import { setClientForDestination } from "../utils/whitelabel";
import { SearchParamKeys } from "../constants/constants";

export const useNavigateClient = (): NavigateFunction => {
  const navigate = useNavigate();

  return (to: string | Partial<unknown>, options?: NavigateOptions) => {
    const searchParams = new URLSearchParams(window.location.search);
    const client = searchParams.get("client");
    const toCopy = setClientForDestination(client, to);
    navigate(toCopy, options);
  };
};

export const useNavigateClientNewTab = (): (to: string, params?: URLSearchParams) => void => {
  return (to: string, params?: URLSearchParams) => {
    let newParams = params;
    if(!params) {
      newParams = new URLSearchParams();
    }
    const searchParams = new URLSearchParams(window.location.search);
    const client = searchParams.get("client");
    if(client) {
      newParams.set(SearchParamKeys.EXPERIENCE_QUERY_IDENTIFIER, client);
    }
    const location = `${to}?${newParams.toString()}`;
    // const location = setClientForDestination(client, to);
    window.open(location, "_blank", "noopener, noreferrer");
  };
};
